import { useEffect } from "react";
import { UserProvider } from "context";
import "@fortawesome/fontawesome-free/css/all.min.css";
import AppRoutes from "app/AppRoutes";
import { applyTenantToDocument } from "config/tenant";

function App() {
  // Titre de l'onglet, méta description et favicon : figés dans
  // public/index.html à la construction, donc communs à toutes les sociétés.
  // On les remplace par ceux de la société servie, sinon l'onglet afficherait
  // la marque d'une autre.
  useEffect(() => {
    void applyTenantToDocument();
  }, []);

  return <AppRoutes />;
}

function AppWrapper() {
  return (
    <UserProvider>
      <App />
    </UserProvider>
  );
}

export default AppWrapper;
